import React, { useEffect, useState } from 'react';
import { Tabs } from 'antd';
import IntegrationPreferences from './IntegrationPreferences';
import styles from './profile.module.sass';
import UserSettings from '../UserSettings';
import APIAccessSettings from '../APIAccessSetings';
import OrganizationProfile from '../OrganizationProfile';
import { useDispatch } from 'react-redux';
import { changeTitle } from '../../../../redux/actions/app';
import { STATUS } from '../../../../redux/constants';
import PermissionDeniedPage from '../../../../shared-components/PermissionDeniedPage';
import LoadingSilentPush from '../../../../shared-components/LoadingSilentPush';

const { TabPane } = Tabs;

function Profile(props) {
  const [activeTab, setActiveTab] = useState(
    sessionStorage.getItem('activeTab') ?? 'organisation',
  );
  const dispatch = useDispatch();
  dispatch(changeTitle('Organization Settings', null));

  useEffect(() => {
    props.loadMySubscriptionPlan();
    document.title = 'Organization Settings - Silent Push';
  }, []);

  useEffect(() => {
    if (props?.user?.is_organization_admin === true) {
      props.loadUsers();
    }
    //props.loadSplunk();
    // props.loadSlack();
    //props.loadMTeams();
    //props.loadAPIAccess();
    props.loadAPIAccess();
    props.loadOrganization();
    sessionStorage.setItem('activeTab', activeTab);
  }, [activeTab]); // eslint-disable-line react-hooks/exhaustive-deps

  function setActiveTabHandler(tabKey) {
    sessionStorage.setItem('activeTab', tabKey);
    setActiveTab(sessionStorage.getItem('activeTab'));
  }

  return props.mySubscriptionPlanStatus === STATUS.LOADED ? (
    props.mySubscriptionPlan?.has_access_to_org_settings ? (
      <div className={styles.container}>
        <Tabs
          defaultActiveKey={activeTab}
          type="card"
          onChange={setActiveTabHandler}
        >
          <TabPane
            className={styles.tab_pane}
            tab="Organization"
            type="card"
            key="organisation"
          >
            <OrganizationProfile loadOrganization={props.loadOrganization()} />
          </TabPane>

          {props?.user?.is_organization_admin === true && (
            <TabPane
              className={styles.tab_pane}
              tab="Users"
              type="card"
              key="users"
            >
              <UserSettings />
            </TabPane>
          )}

          {/* <TabPane
            className={styles.tab_pane}
            tab="Integrations"
            key="integrations"
          >
            <IntegrationPreferences
              splunkSettings={props.splunkSettings}
              updateSplunk={props.updateSplunk}
              saveSplunk={props.saveSplunk}
              deleteSplunk={props.deleteSplunk}
              slackSettings={props.slackSettings}
              updateSlack={props.updateSlack}
              saveSlack={props.saveSlack}
              deleteSlack={props.deleteSlack}
              mTeamsSettings={props.mTeamsSettings}
              updateMTeams={props.updateMTeams}
              saveMTeams={props.saveMTeams}
              deleteMTeams={props.deleteMTeams}
            />
          </TabPane> */}

          <TabPane
            className={styles.tab_pane}
            tab="API Keys"
            type="card"
            key="api_keys"
          >
            <APIAccessSettings />
          </TabPane>
        </Tabs>
      </div>
    ) : (
      <PermissionDeniedPage />
    )
  ) : (
    <LoadingSilentPush size={80} positionCenter />
  );
}

export default Profile;
